export type PaginationRequest = {
	limit: number
	skip: number
}

export type PaginationResponse = {
	limit: number
	skip: number
	totalCount: number
	filteredCount: number
	hasMore: boolean
}

export enum Unit {
	KgCo2 = "kgCo2",
	Kg = "kg",
	Tons = "t",
	M3 = "M3",
	KgPerTons = "kg/t",
}

// Shared measurement and transaction types
export interface Measurement {
	amount: number
	unit: string
}

export interface MeasurementView {
	quantity: number
	unit: string
}

export interface ProofView {
	identifier: string
}

export interface Transaction {
	timestamp: string
	proof: ProofView
}

export interface BuildingDetails {
	projectId: string
	projectTitle: string
	description: string | null
	completion: string | null
	city: string
	country: string
	published: boolean
	buildingImage: string | null
}

export type EmissionsResponse = {
	cycle: string
	hash: string
	totalStorage: TotalStorage
	steps: EmissionStepResponse[]
}

export interface EmissionStepResponse {
	startDate: string
	endDate: string
	proof: ProofView
	biogenic: number
	fossil: number
	name: string
}

export type TotalStorage = {
	biogenic: number
	fossil: number
}

export interface HistoryCardResponseData {
	totalRecords: number
	records: HistoryCardData[]
}

export interface HistoryCardData {
	type: string
	timestamp: string
	data: any
}
